import { lazy } from "react";
import { BASE_PATH } from "context/SiteSettingsContext/utils";
import { ERouteMappingKeys } from "./routeKeys";

export const whatsNewRoutes = {
  [ERouteMappingKeys.WHATS_NEW]: {
    id: "whats-new",
    path: "/whats-new",
    components: {
      [BASE_PATH]: lazy(() =>
        import("pages/Sections/WhatsNew").then((p) => ({
          default: p.WhatsNew,
        })),
      ),
    },
  },
};
